export const validateEmail = (email) => {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const validatePassword = (password) => {
  var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!_%*?&]{8,}$/;
  return re.test(password);
};

export const trimCharecter = (str) => {
  str = str || "";
  if (str.length > 35) {
    return `${str.substring(0, 35)}...`;
  } else {
    return str;
  }
};
